export const truncateText = (text: string, maxLength: number = 120): string => {
  if (!text || text.length <= maxLength) return text;

  const truncated = text.slice(0, maxLength);
  const lastSpace = truncated.lastIndexOf(' ');

  if (lastSpace > 0) {
    return truncated.slice(0, lastSpace) + '...';
  }

  return truncated + '...';
};

export const formatTime = (date: Date | string | number | null | undefined): string => {
  if (date == null) return '';
  const d = date instanceof Date ? date : new Date(date);
  if (isNaN(d.getTime())) return '';
  return d.toLocaleTimeString('es-ES', { hour: '2-digit', minute: '2-digit' });
};

// Aceptamos Date | string | number para tolerar callers que pasan la
// fecha tal como llega de Supabase (string 'YYYY-MM-DD'). Antes petaba
// con 'r.toLocaleDateString is not a function'.
const toDate = (v: Date | string | number | null | undefined): Date | null => {
  if (v == null) return null;
  if (v instanceof Date) return isNaN(v.getTime()) ? null : v;
  const d = new Date(v);
  return isNaN(d.getTime()) ? null : d;
};

export const formatDate = (date: Date | string | number | null | undefined): string => {
  const d = toDate(date);
  if (!d) return '';
  return d.toLocaleDateString('es-ES', { day: 'numeric', month: 'short', year: 'numeric' });
};

export const formatDateTime = (date: Date | string | number | null | undefined): string => {
  const d = toDate(date);
  if (!d) return '';
  return `${formatDate(d)} ${formatTime(d)}`;
};

// Formatea un importe con símbolo de moneda usando Intl.NumberFormat.
// EUR: '1.234,56 €' · USD: '1.234,56 US$' · fallback: código plano.
export const formatCurrency = (amount: number | null | undefined, currency: string = 'EUR'): string => {
  const value = Number(amount || 0);
  const cur = (currency || 'EUR').toUpperCase();
  try {
    return new Intl.NumberFormat('es-ES', {
      style: 'currency',
      currency: cur,
      maximumFractionDigits: 2,
    }).format(value);
  } catch {
    // Currency inválido → fallback con símbolo €.
    return `${value.toLocaleString('es-ES', { maximumFractionDigits: 2 })} ${cur}`;
  }
};

// Devuelve el símbolo de una divisa (€, $, £, etc). Útil como prefijo
// en inputs de número.
export const currencySymbol = (currency: string = 'EUR'): string => {
  const cur = (currency || 'EUR').toUpperCase();
  const map: Record<string, string> = { EUR: '€', USD: '$', GBP: '£' };
  if (map[cur]) return map[cur];
  try {
    const parts = new Intl.NumberFormat('es-ES', { style: 'currency', currency: cur })
      .formatToParts(0);
    return parts.find(p => p.type === 'currency')?.value || cur;
  } catch {
    return cur;
  }
};
